import Section from "@src/components/section"
import React from "react"
import * as styles from "./rules.module.scss"

const Rules = () => {
  return (
    <div className={styles.container}>
      <Section title="关于开发平台">
        <p>
          本次游戏创作活动不限制任何开发平台和引擎，但在提交作品时需要你提交能够在
          Windows 或 MAC 上运行的版本，也欢迎额外提供多余版本，比如移动端等；
        </p>

        <p>
          但是你不能提交游戏中的游戏，比如在马里奥制造、Dreams、Roblox等中开发的游戏。
        </p>
      </Section>
      <Section title="关于开发素材版权">
        <p>
          你需要有提交作品中所涉及的各种软件、素材资源的版权，在没有版权时我们建议你优先考虑使用开源资源。另外你可以使用预先存在的代码、库和函数、美术、音频等。但是希望你不要在正式公布主题前提前为本次活动预写代码。
        </p>
        <p>
          各位创作者在本次活动中创造出来的作品版权将归你们的创作团队共同所有，参与本次活动将默认同意提交的作品可在核聚变现场及机核网网站内使用（包括但不限于核聚变现场展示、机核网下载试玩等）。
        </p>
      </Section>
      <Section title="BOOOM 有评选吗？">
        <p>
          <strong className="smTitle">
            【核聚变现场，玩家选出最受欢迎奖】
          </strong>
          <br />
          在核聚变现场，开发者可以根据自己游戏的特点布置自己的展示摊位，并向玩家们展示试玩，玩家试玩后将会用我们设计的“特殊贴纸”，给予自己最喜欢的游戏作品，评出“现场最受欢迎奖”并得到一些小奖品。
        </p>
        <p>
          后续会举办 BOOOM
          游戏试玩活动，所有玩家均可在网站内玩到你的游戏，并选出“线上最受欢迎TOP
          1”。详细时间将根据线下展出调整，后续将会公布详情。
        </p>
      </Section>
      <Section title="哪些行为会被拒绝接收？">
        <ol>
          <li>
            提交18+、过度色情、暴力、反社会等内容，可参考
            <a href="https://www.esrb.org/">ESRB评级</a>
          </li>
          <li>任何的抄袭、使用无版权内容；</li>
          <li>5月4日24点之前未能提交作品；</li>
          <li>提交并不能运行的游戏文件。</li>
        </ol>
      </Section>
    </div>
  )
}

export default Rules
